import React, { useEffect, useRef, useState } from 'react';
import OftadehLayout from '../../components/OftadehLayout/OftadehLayout';
import { Button, CircularProgress } from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import { API_URL, BASE_IMG_URL, getDefName } from '../../constants';
import { getHospitalList, getLanguageList, getProductList, getProductManagerList, getProductTypeList } from '../../constants/PromiseHttp';
import swal from '@sweetalert/with-react';
import axiosInstance from '../../constants/AxiosInstance';
import moment from 'moment';
import { exportExcel } from '../../components/ExportData/ExcelExport';
import { GridSearchIcon } from '@material-ui/data-grid';

import GetAppRoundedIcon from '@material-ui/icons/GetAppRounded';
import CustomListHeader from '../../components/Custom/CustomListHeader';

const ProductListPage = (props) => {
  const { history } = props;
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  const [types, setTypes] = useState([]);
  const [hospitals, setHospitals] = useState([]);
  const [languages, setLanguages] = useState([]);

  const tableStateRef = useRef([]);

  const getData = () => {
    setLoading(true);
    if (sessionStorage.getItem('bt_role') === 'SYS_MGR') {
      getProductManagerList(sessionStorage.getItem('bt_user')).then((result) => {
        setLoading(false);
        setData(result);
      });
    } else {
      getProductList().then((result) => {
        setLoading(false);
        setData(result);
      });
    }
  };

  const rowClick = (rowData) => {
    //console.log(data);
    history.push(`/pages/product/detail?type=edit&id=${rowData.id}`);
  };

  const handleFilteredExcelDownload = () => {
    const displayData = tableStateRef.current || [];
    const filteredData = displayData.map(({ dataIndex }) => data[dataIndex]);
    exportExcel({ jsonData: filteredData, type: 'Product', languages, types, hospitals });
  };

  const cols = [
    {
      name: 'id',
      label: 'id',
      options: {
        filter: false,
        sort: true,
        display: false,
        viewColumns: false,
      },
    },
    {
      name: 'id',
      label: 'No.',
      options: {
        filter: false,
        sort: true,
        display: true,
        viewColumns: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return tableMeta.rowIndex + 1;
        },
      },
    },
    {
      name: 'languageId',
      label: 'Language',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          const lang = languages.find((lang) => lang.id === value);
          return lang ? lang[getDefName()] : '';
        },
      },
    },
    {
      name: 'typeId',
      label: 'Category',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          const type = types.find((_type) => _type.id === value);
          return type ? type[getDefName()] : '';
        },
      },
    },
    {
      name: 'hospitalId',
      label: 'Hospital',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          const hos = hospitals.find((_hos) => _hos.id === value);
          return hos ? hos['name_ko'] : '';
        },
      },
    },
    {
      name: 'thumbs',
      label: 'Image',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          if (value && value.length > 0) {
            const url = `${BASE_IMG_URL}` + value[0].key;
            return <img src={url} width={48} alt={value[0].name} />;
          } else {
            const mainImg = tableMeta.rowData[tableMeta.columnIndex + 1];
            if (mainImg && mainImg.length > 0) {
              const url = `${BASE_IMG_URL}` + mainImg[0].key;
              return <img src={url} width={48} alt={mainImg[0].name} />;
            } else {
              return '';
            }
          }
        },
      },
    },
    {
      name: 'images',
      label: 'Main',
      options: {
        filter: false,
        sort: true,
        display: false,
      },
    },
    {
      name: 'name_ko',
      label: 'Product Name',
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: 'hidden',
      label: 'Show/Hide',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return value ? <span style={{ color: 'grey' }}>Hide</span> : <span style={{ color: 'green', fontWeight: 500 }}>Show</span>;
        },
      },
    },
    {
      name: 'createdAt',
      label: 'Registration Date',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return moment(Number(value)).format('YYYY-MM-DD HH:mm');
        },
      },
    },
    {
      name: 'viewCnt',
      label: 'View Count',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return value || 0;
        },
      },
    },

    {
      name: 'detail',
      label: 'Detail',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Button color="primary" onClick={() => rowClick(data[tableMeta.rowIndex])}>
              <GridSearchIcon />
            </Button>
          );
        },
      },
    },
  ];

  const rowDelete = (row) => {
    let ids = [];
    row.data.map((r) => {
      ids.push(data[r.dataIndex].id);
      return r;
    });
    let delParam = {
      ids: ids.toString(),
    };
    swal({
      title: 'Are you sure you want to delete?',
      text: '',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        axiosInstance.post(`${API_URL}/product/deleteIds`, delParam, { headers: { Pragma: 'no-cache' } }).then((response) => {
          swal('It is deleted.', {
            icon: 'success',
          });
          getData();
        });
      } else {
        getData();
      }
    });
  };

  const options = {
    print: false,
    filter: false,
    filterType: 'checkbox',
    selectableRows: 'multiple',
    viewColumns: false,
    download: false,
    // onRowClick: rowClick,
    onRowsDelete: rowDelete,

    onTableChange: (action, tableState) => {
      tableStateRef.current = tableState.displayData;
    },
    customToolbar: () => (
      <Button
        variant="contained"
        onClick={handleFilteredExcelDownload}
        startIcon={<GetAppRoundedIcon />}
        style={{ color: '#ffffff', backgroundColor: '#1d6f42' }}
      >
        Excel download
      </Button>
    ),
  };

  useEffect(() => {
    getData();
    getProductTypeList().then((result) => {
      setTypes(result);
    });
    getHospitalList(true).then((result) => {
      setHospitals(result);
    });
    getLanguageList().then((result) => {
      setLanguages(result);
    });
  }, []);
  console.log('data?', data);
  return (
    <OftadehLayout>
      <CustomListHeader history={history} url={'/pages/product/edit?type=new'} type="Product" />
      {/*<OftadehBreadcrumbs path={history} />*/}
      <MUIDataTable title={''} data={data} columns={cols} options={options} />
      {loading && (
        <div style={{ position: 'fixed', left: '50%', top: '50%', transform: 'translate(-50%, -50%)', zIndex: 999 }}>
          <CircularProgress color={'secondary'} />
        </div>
      )}
    </OftadehLayout>
  );
};

export default ProductListPage;
